// extracted by mini-css-extract-plugin
export default {"yundingLogin":"yundingLogin_yundingLogin__lRTx2","header":"yundingLogin_header__z0qcc","logo":"yundingLogin_logo__SLpkW"};